import { useCallback } from 'react';
import { rage, useObservable } from '~/rage';
import {
	IModalReplyDefault,
	ModalButtonColor,
	ModalType,
	WalletType,
} from '~/shared';
import { useLayoutSelector } from '../redux';

const useStartExam = () => {
	const examList = useObservable(rage.drivingSchool.getExams());
	const selectedIndex = useLayoutSelector(
		(state) => state.drivingSchool.selectedIndex,
	);
	const modalState = useObservable(rage.modal.getCurrentModal());

	const handleStartExam = useCallback(() => {
		if (modalState) {
			return;
		}

		rage.modal.showModal(
			{
				type: ModalType.Price,
				title: 'Подтверждение',
				text: `Вы действительно хотите оплатить обучение на "${
					examList[selectedIndex - 1].name
				}"?`,
				acceptButton: { text: 'Оплатить', color: ModalButtonColor.Success },
				cancelButton: { text: 'Отменить', color: ModalButtonColor.Secondary },
				price: examList[selectedIndex - 1].price,
				wallet: WalletType.Cash,
			},
			({ isAccepted }: IModalReplyDefault) => {
				if (isAccepted) {
					rage.drivingSchool.startExam(examList[selectedIndex - 1].id);
				}
			},
		);
	}, [modalState, examList, selectedIndex]);

	return { handleStartExam };
};

export { useStartExam };
